"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowInLinePageIconType = void 0;
/**
 * 设置行内页面 icon 的显示和隐藏
 */
var ShowInLinePageIconType;
(function (ShowInLinePageIconType) {
    ShowInLinePageIconType["SHOW_ALL"] = "SHOW_ALL";
    ShowInLinePageIconType["SHOW_CUSTOM"] = "SHOW_CUSTOM";
    ShowInLinePageIconType["HIDE"] = "HIDE";
})(ShowInLinePageIconType = exports.ShowInLinePageIconType || (exports.ShowInLinePageIconType = {}));
